import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tab-switcher" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RedesignedSwitchComponent = _resolveComponent("RedesignedSwitchComponent")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_RedesignedSwitchComponent, {
      class: "tab-switcher__switch",
      checked: _ctx.isChecked,
      textTrue: _ctx.textTrue,
      textFalse: _ctx.textFalse,
      mode: _ctx.mode,
      onSwitchHandler: _ctx.switchHandler
    }, null, 8, ["checked", "textTrue", "textFalse", "mode", "onSwitchHandler"]),
    _createElementVNode("div", {
      class: _normalizeClass(['tab-switcher__tab', _ctx.isChecked ? 'tab--active' : 'tab--offscreen'])
    }, [
      _renderSlot(_ctx.$slots, "first-tab", {}, undefined, true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(['tab-switcher__tab', !_ctx.isChecked ? 'tab--active' : 'tab--offscreen'])
    }, [
      _renderSlot(_ctx.$slots, "second-tab", {}, undefined, true)
    ], 2)
  ]))
}